<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        idProjeto: '',
        projetos: [],
        relatorio: [],
        projeto: null,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelSaldos")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      gerar() {
        this.relatorio = [];
        this.setarProjeto();
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.saldos(this.idProjeto)
          })
          .then(resultado => {
            this.relatorio = resultado.groupBy('metaEtapa');
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      setarProjeto() {
        this.projeto = this.idProjeto ? this.projetos.find(p => p.idProjeto == this.idProjeto) : null; 
      },
      calcularSaldo(rubrica) {
        if (this.projeto.utilizarDefinicaoSubrubrica) {
          return rubrica.valorSubrubrica + rubrica.valorProvisao + rubrica.valorLancado - rubrica.valorPagar;
        } else {
          return rubrica.valorRubrica + rubrica.valorProvisao + rubrica.valorLancado - rubrica.valorPagar;
        }
      },
      calcularSaldoTotal(metaEtapa) {
        let total = null;
        for (let i = 0; i < metaEtapa.length; i = i + 1) {
          total = total + this.calcularSaldo(metaEtapa[i]);
        }
        return total;
      }
    },
    computed: {
      projetoSelecionado() {
        return this.idProjeto ? this.projetos.find(p => p.idProjeto == this.idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Saldos`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      $('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this, 'idProjeto', this.value);
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select
                  id="projeto"
                  class="form-control"
                  v-model="idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button
              id="gerar"
              type="button"
              class="btn btn-primary"
              @click="gerar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="Object.keys(relatorio).length !== 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Saldos" borda=""></cabecalho-relatorio>

    <div class="row" v-if="Object.keys(relatorio).length !== 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ projeto.nomeProjeto }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-bordered no-margin-bottom" v-for="metaEtapa in relatorio">
                <thead>
                  <tr v-if="metaEtapa[0].metaEtapa !== ''">
                    <th colspan="2">{{ metaEtapa[0].metaEtapa }}</th>
                  </tr>
                  <tr>
                    <th>Rubrica</th>
                    <th class="text-right" style="width: 200px">Saldo(=)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="rubrica in metaEtapa">
                    <td>{{ rubrica.nomeRubrica }}</td>
                    <td class="text-right">{{ calcularSaldo(rubrica) | formatarNumero }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th>Saldo Total</th>
                    <th class="text-right" style="width: 200px">{{ calcularSaldoTotal(metaEtapa) | formatarNumero }}</th>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Saldos.vue